import { AppDataState } from './app-data-store';
import { UserNotificationCount } from './interface/user-notification-count';

export const SET_GET_USER_NOTIFICATION_COUNT = 'SET_GET_USER_NOTIFICATION_COUNT';

export type SetGetUsetNotificationCountAction = {
  type: typeof SET_GET_USER_NOTIFICATION_COUNT;
  payload: UserNotificationCount;
};

// redux update store action
export const setGetUserNotificationCountAction = (
  payload: UserNotificationCount
): SetGetUsetNotificationCountAction => {
  return {
    type: SET_GET_USER_NOTIFICATION_COUNT,
    payload,
  };
};

// redux reducer handler - state updater
export const setGetUserNotificationCountHandler = (
  state: AppDataState,
  action: SetGetUsetNotificationCountAction
): AppDataState => {
  return {
    ...state,
    userNotificationCount: action.payload,
  };
};
